"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderContext = void 0;
const react_1 = require("react");
exports.HeaderContext = (0, react_1.createContext)({});
